import type { getCreateTaskParameters } from 'src/services/helpers/artworkApiParamsPacker'

export function mergePromptHelperParamsToParameter(
  parameters: ReturnType<typeof getCreateTaskParameters>,
  opts: {
    userWantToEnable?: boolean
    enable?: boolean
  },
) {
  const ret: ReturnType<typeof getCreateTaskParameters> = {
    ...parameters,
  }

  if (parameters?.promptHelper) {
    ret.promptHelper = {
      ...parameters.promptHelper,
      userWantToEnable: opts.userWantToEnable,
      enable: opts.enable,
    }
  } else {
    ret.promptHelper = {
      withStage: opts.enable,
      userWantToEnable: opts.userWantToEnable,
      enable: opts.enable,
      forcePromptHelperDetectionSide: undefined,
    }
  }

  return ret
}
